export function useCountdown(userTimeRange: ComputedRef<number>) {
  const restTime = ref(0)
  const isBackPage = useDocumentVisibility()
  const startLeaveTime = ref(0)

  // toggle visibility fix time
  watch(() => isBackPage.value, () => {
    if (isBackPage.value === 'hidden') {
      startLeaveTime.value = +new Date()
    }
    else if (isBackPage.value === 'visible') {
      const leaveTime = Math.ceil((+new Date() - startLeaveTime.value) / 1000)
      if (restTime.value > leaveTime)
        restTime.value -= leaveTime
    }
  })

  const { resume, pause, isActive } = useIntervalFn(() => {
    restTime.value--
    if (restTime.value <= 0)
      pause()
  }, 1000, { immediate: false })

  watchOnce(() => userTimeRange.value, () => {
    if (!userTimeRange.value)
      return
    restTime.value = userTimeRange.value
    resume()
  }, { immediate: true })

  function addTime(seconds: number) {
    restTime.value += seconds
  }

  return {
    addTime,
    restTime,
    isActive,
  }
}
